import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HdCurrentTableComponent } from './hd-current-table.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { HdSpaceModule } from '../hd-space/hd-space.module';

@NgModule({
  imports: [
    CommonModule,
    NzTableModule,
    HdSpaceModule
  ],
  declarations: [HdCurrentTableComponent],
  exports: [HdCurrentTableComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class HdCurrentTableModule { }
